import { ApiHandler } from '@/shared/api/ApiHandler'
import { User } from '@/shared/interfaces/User'

export async function principalGetProfile(): Promise<User> {
  return await ApiHandler.get('profile')
}
